module.exports = __webpack_public_path__ + "static/media/IOG_Logo.83772d0f.svg";